import React from "react";
import ReactDOM from "react-dom";
import Router from "./Router";
import { BrowserRouter } from "react-router-dom";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducers";
// import CategoryContext from "./hooks/context";
// import CategoryReducer from "./hooks/reducer";

import "./index.css";
import "semantic-ui-css/semantic.min.css";
import * as serviceWorker from "./serviceWorker";

// store
const store = createStore(rootReducer, composeWithDevTools());

const App = () => {
  // const initialState = useContext(CategoryContext);
  // const [state, dispatch] = useReducer(CategoryReducer, initialState);
  return (
    <Provider store={store}>
      <BrowserRouter>
        {/* <CategoryContext.Provider value={{ state, dispatch }}> */}
        <Router />
        {/* </CategoryContext.Provider> */}
      </BrowserRouter>
    </Provider>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));

serviceWorker.unregister();
